import { useCallback, useSyncExternalStore } from 'react';

/**
 * Reactive `window.matchMedia` as a boolean — re-renders when the query's match
 * state flips (e.g. the viewport crosses a width breakpoint). SSR / no-window
 * falls back to `false` ("does not match").
 *
 * @example const isNarrow = useMediaQuery('(max-width: 796px)');
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [query],
  );
  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
